import Skeleton from 'elements/Skeleton';

export const CollectionSkeleton = () => (
  <Skeleton height={100}>
    {/* First Line */}
    <rect x="0" y="0" width="75%" height="20px" rx="10px" />
    <rect x="80%" y="0" width="30px" height="20px" rx="10px" />
    {/* Second Line */}
    <rect x="0" y="30px" width="75%" height="20px" rx="10px" />
    <rect x="80%" y="30px" width="30px" height="20px" rx="10px" />
    {/* Third Line */}
    <rect x="0" y="60px" width="75%" height="20px" rx="10px" />
    <rect x="80%" y="60px" width="30px" height="20px" rx="10px" />
  </Skeleton>
);
